<template lang="pug">
#landing.animated.fadeIn
  .top-wrapper(v-if="!whiteLabel")
    .top
      .logo
        img(v-if="cnyMode" :src="logoCNYPath")
        img(v-else :src="logoPath")
        //- img(src="/images/logo/logo_cny.png?v=12")
        //- .xmas-deco
        //-   img(src="/images/xmas_deco.png?v=12")
      //- button.login-btn(v-if="!whiteLabel" data-toggle="modal" data-target="#login-modal") {{ $t("ui.login") }}
  section.slider-wrap
    .bg-landing
      //- canvas#sky
    #cny-rain1
    #cny-rain2
    //- #cny-rain3
      //- #euro-ribbon-rain
      //- #euro-ribbon-rain2
      //- #euro-ribbon-rain3
    //- #xmas-rain1
    //- #xmas-rain2
    //- #xmas-rain3
    #main-carousel.carousel.slide(data-ride="carousel")
      ol.carousel-indicators
        li.active(data-target="#main-carousel" data-slide-to="0")
        li(data-target="#main-carousel" data-slide-to="1")
        li(data-target="#main-carousel" data-slide-to="2")
        li(data-target="#main-carousel" data-slide-to="3")
        li(data-target="#main-carousel" data-slide-to="4")
        template(v-if="esports2")
          li(data-target="#main-carousel" data-slide-to="5")
        li(data-target="#main-carousel" data-slide-to="6")
      .carousel-inner
        //- #worldcup.carousel-item.worldcup.active
        //-   .banner-text
        //-     h1
        //-       img(:src='getImgUrl("worldcup_title.png')
        //-     p
        //-       | {{ $t("message.banner11a") }}
        //-       br
        //-       | {{ $t("message.banner11b") }}
        //-       br
        //-       | {{ $t("message.banner11c") }}
        //-   .banner-image
        //-     img.img-fluid.animate-image(:src='getImgUrl("banner-11-2.png?v=12")')
        //-     img.img-fluid(:src='getImgUrl("banner-11-1.png?v=12")')
        //- #dragonboat.carousel-item.dragonboat.active
        //-   .banner-text
        //-     h1.desktop
        //-       img.img-fluid(:src='getImgUrl("dragonboat_title.png')
        //-     h1.mobile
        //-       img.img-fluid.dragonboat-title(:src='getImgUrl("dragonboat_title_mobile.png')
        //-   .banner-image
        //-     img.img-fluid.animate-image(:src='getImgUrl("banner-10-2.png?v=12")')
        //-     img.img-fluid(:src='getImgUrl("banner-10-1.png?v=12")')
        //- #songkran.carousel-item.songkran.active
        //-   .banner-text
        //-     h1
        //-       | {{ $t("message.banner15a") }}
        //-       br
        //-       | {{ $t("message.banner15b") }}
        //-     p
        //-       | {{ $t("message.banner15c") }}
        //-   .banner-image
        //-     img.img-fluid.animate-image(:src='getImgUrl("banner-15-2.png?v=12")')
        //-     img.img-fluid(:src='getImgUrl("banner-15-1.png?v=12")')
        //- #raya.carousel-item.raya.active
        //-   .banner-text
        //-     h1
        //-       | {{ $t("message.banner16a") }}
        //-       //- br
        //-       //- | {{ $t("message.banner16b") }}
        //-   .banner-image
        //-     img.img-fluid.animate-image(:src='getImgUrl("banner-16-2.png?v=12")')
        //-     img.img-fluid(:src='getImgUrl("banner-16-1.png?v=12")')
        //- #live22.carousel-item.live22
        //-   .banner-image
        //-     img.img-fluid.animate-image(:src='getImgUrl("banner-14-2.png?v=12")')
        //-     img.img-fluid(:src='getImgUrl("banner-14-1.png?v=12")')
        #efight.carousel-item.efight.active
          .banner-text
            h1
              | {{ $t("message.banner6a") }}
              br
              | {{ $t("message.banner6b") }}
            p
              | {{ $t("message.banner6c") }}
          .banner-image
            img.img-fluid.animate-image(:src='getImgUrl("banner-08-2.png?v=12")')
            img.img-fluid(:src='getImgUrl("banner-08-1.png?v=12")')
        #vgames.carousel-item.vgames
          .banner-text
            h1
              | {{ $t("message.banner8a") }}
              br
              | {{ $t("message.banner8b") }}
            p
              | {{ $t("message.banner8c") }}
              br
              | {{ $t("message.banner8d") }}
          .banner-image
            img.img-fluid.animate-image(:src='getImgUrl("banner-12-2.png?v=12")')
            img.img-fluid(:src='getImgUrl("banner-12-1.png?v=12")')
        //- #tournament.carousel-item.tournament
        //-   .banner-text
        //-     h1
        //-       | {{ $t("message.banner13a") }}
        //-     p
        //-       | {{ $t("message.banner13b") }}
        //-   .banner-image
        //-     img.img-fluid.animate-image(:src='getImgUrl("banner-13-2.png?v=12")')
        //-     img.img-fluid(:src='getImgUrl("banner-13-1.png?v=12")')
        template(v-if="esports2")
          #efight2.carousel-item.efight2
            .banner-text
              h1
                | {{ $t("message.banner7a") }}
                br
                | {{ $t("message.banner7b") }}
              p
                | {{ $t("message.banner7c") }}
                br
                | {{ $t("message.banner7d") }}
            .banner-image
              img.img-fluid.animate-image(:src='getImgUrl("banner-09-2.png?v=12")')
              img.img-fluid(:src='getImgUrl("banner-09-1.png?v=12")')
        #sport.carousel-item
          .banner-text
            h1
              | {{ $t("message.banner1a") }}
              br
              | {{ $t("message.banner1b") }}
            p
              | {{ $t("message.banner1c") }}
          .banner-image
            img.img-fluid.animate-image(:src='getImgUrl("banner-01-2.png?v=12")')
            template(v-if="brand != 'IBCBET'")
              img.img-fluid(:src='getImgUrl("banner-01-1.png?v=12")')
            template(v-else)
              img.img-fluid(:src='getImgUrl("banner-01-1-gs.png?v=12")')
        #casino.carousel-item.casino
          .banner-text
            h1
              | {{ $t("message.banner2a") }}
              br
              | {{ $t("message.banner2b") }}
            p
              | {{ $t("message.banner2c") }}
          .banner-image
            img.img-fluid.animate-image(:src='getImgUrl("banner-02-2.png?v=12")')
            img.img-fluid(:src='getImgUrl("banner-02-1.png?v=12")')
        #games.carousel-item.games
          .banner-text
            h1
              | {{ $t("message.banner3a") }}
              br
              | {{ $t("message.banner3b") }}
            p
              | {{ $t("message.banner3c") }}
          .banner-image
            img.img-fluid.animate-image(:src='getImgUrl("banner-03-2.png?v=12")')
            img.img-fluid(:src='getImgUrl("banner-03-1.png?v=12")')
        #live.carousel-item.live
          .banner-text
            h1
              | {{ $t("message.banner5a") }}
              br
              | {{ $t("message.banner5aa") }}
            p
              | {{ $t("message.banner5b") }}
              br
              | {{ $t("message.banner5c") }}
          .banner-image
            img.img-fluid.animate-image(:src='getImgUrl("banner-05-2.png?v=12")')
            template(v-if="brand != 'IBCBET'")
              img.img-fluid(:src='getImgUrl("banner-05-1.png?v=12")')
            template(v-else)
              img.img-fluid(:src='getImgUrl("banner-05-1-gs.png?v=12")')
      a.carousel-control-prev(href="#main-carousel" role="button" data-slide="prev")
        span.carousel-control-prev-icon(aria-hidden="true")
        span.sr-only Previous
      a.carousel-control-next(href="#main-carousel" role="button" data-slide="next")
        span.carousel-control-next-icon(aria-hidden="true")
        span.sr-only Next
  loginModal(v-if="!whiteLabel")
  section.lobby-wrap
    .inner-wrap
      .lobbyinner
        //- .euro-event
        //-   .border-glow
        //-     .euro-box-wrapper
        //-       .euro-box
        //-         .euro-logo
        //-           img.img-fluid(src='images/euro_logo.png')
        //-         .countdown-wrapper
        //-           .date {{ $t("ui.euroDate") }}
        //-           #countdown
        //-           .countdown-info
        //-             .text {{ $t("message.days") }}
        //-             .space
        //-             .text {{ $t("message.hours") }}
        //-             .space
        //-             .text {{ $t("message.mins") }}
        //-             .space
        //-             .text {{ $t("message.secs") }}
        //-           p#note.euro-note.d-none
        //-   div
        //-     img.img-fluid(src='images/grey-line.png')
        //- .worldcup-timer
        //-   .timer-logo
        //-     img.img-fluid(src='images/worldcup_timer_logo.png')
        //-   .worldcup-timer-wrapper.flex-grow-1
        //-     h4 {{ $t("ui.time_remaining") }}
        //-     .counter-wrapper.d-flex.justify-content-center
        //-       #timer
        .row
          .col-12.mobile
            .lobby-item
              .card-flip(data-toggle="modal" data-target="#login-modal")
                .front
                  .image-wrap
                    img(:src='getImgUrl("sportsbook_mobile.jpg?v=12")')
                  .info
                    h1 {{ $t("ui.sportsbook").toUpperCase() }}
                .back
                  h3 {{ $t("ui.sportsbook").toUpperCase() }}
                  p
                    | {{ $t("message.bannersb") }}
                  .card-footer
                    button.btn(data-toggle="modal" data-target="#login-modal") {{ $t("ui.play_now") }}
          .col-6.col-md-4
            .lobby-item
              .card-flip(data-toggle="modal" data-target="#login-modal")
                .front
                  .image-wrap
                    img(:src='getImgUrl("casino.jpg?v=12")')
                  .info
                    h1 {{ $t("ui.livecasino").toUpperCase() }}
                .back
                  h3 {{ $t("ui.livecasino").toUpperCase() }}
                  p
                    | {{ $t("message.bannerlc") }}
                    .card-footer
                      button.btn(data-toggle="modal" data-target="#login-modal") {{ $t("ui.play_now") }}
          .col-md-4.desktop
            .lobby-item.sport
              .card-flip(data-toggle="modal" data-target="#login-modal")
                .front
                  .image-wrap
                    img.desktop(:src='getImgUrl("sportsbook.jpg?v=12")')
                  .info
                    h1 {{ $t("ui.sportsbook").toUpperCase() }}
                .back
                  h3 {{ $t("ui.sportsbook").toUpperCase() }}
                  p
                    | {{ $t("message.bannersb") }}
                  .card-footer
                    button.btn(data-toggle="modal" data-target="#login-modal") {{ $t("ui.play_now") }}
          .col-6.col-md-4
            .lobby-item
              .card-flip(data-toggle="modal" data-target="#login-modal")
                .front
                  .image-wrap
                    img(:src='getImgUrl("games.jpg?v=12")')
                  .info
                    h1 {{ $t("ui.slots").toUpperCase() }}
                .back
                  h3 {{ $t("ui.slots").toUpperCase() }}
                  p
                    | {{ $t("message.bannersl") }}
                  .card-footer
                    button.btn(data-toggle="modal" data-target="#login-modal") {{ $t("ui.play_now") }}
      .join-us(v-if="!whiteLabel")
        h1 {{ $t("message.join_us1") }}
        p
          | {{ $t("message.join_us2") }}
        button.join-btn(data-toggle="modal" data-target="#login-modal") {{ $t("message.join_us3") }}
  section.feature-wrap
    .deco1
      img(:src='getImgUrl("football.png?v=12")')
    .deco2
      img(:src='getImgUrl("footballplayer.png?v=12")')
    //- .video-wrap
    //-   iframe(src='https://www.youtube.com/embed/eOsdB7HHADc' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen='')
    .row.featureinner
      .col-12.col-md-6.feature-item
        .icon
          img(:src='getImgUrl("feature_icon1.svg?v=12")')
        .feature-content
          h1 {{ $t("message.icon1a") }}
          p {{ $t("message.icon1b") }}
      .col-12.col-md-6.feature-item
        .icon
          img(:src='getImgUrl("feature_icon2.svg?v=12")')
        .feature-content
          h1 {{ $t("message.icon2a") }}
          p {{ $t("message.icon2b") }}
    .row.featureinner
      .col-12.col-md-6.feature-item
        .icon
          img(:src='getImgUrl("feature_icon3.svg?v=12")')
        .feature-content
          h1 {{ $t("message.icon3a") }}
          p {{ $t("message.icon3b") }}
      .col-12.col-md-6.feature-item
        .icon
          img(:src='getImgUrl("feature_icon4.svg?v=12")')
        .feature-content
          h1 {{ $t("message.icon4a") }}
          p {{ $t("message.icon4b") }}
  footer.footer
    a.switch-desktop.mobile(v-if="!whiteLabel" :href="desktopUrl")
      img.desktop-icon(:src='getImgUrl("desktop-mode.svg?v=12")')
      button {{ $t("ui.switch_to_desktop") }}
    .license
      .image-wrap
        img(:src='getImgUrl("license/01.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/02.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/03.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/04.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/05.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/06.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/07.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/08.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/01.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/01.png?v=12")')
      .image-wrap
        img(:src='getImgUrl("license/01.png?v=12")')
    .tnc(v-if="!whiteLabel")
      .icon
        img(:src='getImgUrl("18plus.svg?v=12")')
      .tnc-content
        h4 {{ $t("message.footer1a") }}
        p
          | {{ $t("message.footer1b") }}
  .tutorial(v-if="!isStandalonePWA && brand != 'IBCBET' && !whiteLabel")
    //- .android.d-flex.align-items-center.justify-content-between(v-if="isAndroid")
    //-   //- a.d-flex.align-items-center.flex-grow-1(href="javascript:void(0);" data-toggle='modal' data-target='#android-homescreen-modal')
    //-   //- a.d-flex.align-items-center.flex-grow-1#addHomescreen(href="javascript:void(0);")
    //-   //-   img.icon(:src='getImgUrl("app_icon.svg?v=12")')
    //-   //-   div Add WBET to home screen
    //-   a.d-flex.align-items-center.flex-grow-1#addHomescreen(href="javascript:void(0);")
    //-     template(v-if="brand == 'IBCBET'")
    //-       img.icon(:src='getImgUrl("app_icon_gs.svg?v=12")')
    //-     template(v-else-if="brand == 'UBETT'")
    //-       img.icon(:src='getImgUrl("app_icon_ub.svg?v=12")')
    //-     template(v-else)
    //-       img.icon(:src='getImgUrl("app_icon.svg?v=12")')
    //-     div Add {{ brand }} to home screen
    //-   .remove(@click="close(0)")
    //-     i.fal.fa-times
    .ios(v-if="isIOS")
      .d-flex.align-items-start
        //- img.icon(:src='getImgUrl("app_icon.svg?v=12")')
        template(v-if="brand == 'IBCBET'")
          img.icon(:src='getImgUrl("app_icon_gs.svg?v=12")')
        template(v-else-if="brand == 'UBETT'")
          img.icon(:src='getImgUrl("app_icon_ub.svg?v=12")')
        template(v-else)
          img.icon(:src='getImgUrl("app_icon.svg?v=12")')
        .flex-grow-1
          | {{ $t("ui.tutorial_tooltips") }}
      .link-wrapper.d-flex.justify-content-end
        a(href="javascropt:void(0);" data-toggle='modal' data-target='#ios-homescreen-modal')
          .mr-4
            i.fas.fa-play
            | &nbsp;{{ $t("ui.tutorial") }}
        div(@click="close(1)") {{ $t("ui.dismiss") }}

</template>

<script>
import config from "@/config";
import loginModal from "@/components/mobile/loginModal";

function specialfx() {
  var cny = 'cny-rain'
  var xmas = 'xmas-rain'

  var css = config.cnyMode ? cny : config.xmasMode ? xmas : ''

  function animm(elm) {
    TweenMax.to(elm, R(6, 15), { y: h + 100, ease: Linear.easeNone, repeat: -1, delay: -5 });
    TweenMax.to(elm, R(2, 8), { x: "+=100", rotationZ: R(0, 180), repeat: -1, yoyo: true, ease: Sine.easeInOut });
    TweenMax.to(elm, R(2, 8), { rotationX: R(0, 360), rotationY: R(0, 360), repeat: -1, yoyo: true, ease: Sine.easeInOut, delay: -5 });
  }

  function R(min, max) {
    return min + Math.random() * (max - min);
  }

  TweenLite.set("#cny-rain1",{perspective:600})
  TweenLite.set(".cny-rain1 img",{xPercent:"-30%",yPercent:"-30%"})

  var total = 50;
  var warp = document.getElementById('cny-rain1'),	w = window.innerWidth , h = window.innerHeight;

  for (var i=0; i<total; i++) {
    var Div = document.createElement('div');
    TweenLite.set(Div,{attr:{class:'cny-rain1'},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
    warp.appendChild(Div);
    animm(Div);
  }

  TweenLite.set("#cny-rain2",{perspective:600})
  TweenLite.set(".cny-rain2 img",{xPercent:"-50%",yPercent:"-50%"})

  var total = 30;
  var warp = document.getElementById("cny-rain2"),	w = window.innerWidth , h = window.innerHeight;

  for (var i=0; i<total; i++) {
    var Div = document.createElement('div');
    TweenLite.set(Div,{attr:{class:'cny-rain2'},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
    warp.appendChild(Div);
    animm(Div);
  }

  // TweenLite.set("#cny-rain3",{perspective:600})
  // TweenLite.set(".cny-rain3 img",{xPercent:"-50%",yPercent:"-50%"})

  // var total = 30;
  // var warp = document.getElementById("cny-rain3"),	w = window.innerWidth , h = window.innerHeight;

  // for (var i=0; i<total; i++) {
  //   var Div = document.createElement('div');
  //   TweenLite.set(Div,{attr:{class:'cny-rain3'},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
  //   warp.appendChild(Div);
  //   animm(Div);
  // }
}

export default {
  components: {
    loginModal
  },
  data() {
    return {
      isStandalonePWA: false,
      isIOS: false,
      isAndroid: false,
      isWindows: false,
      countdown: null,
      hideCountdown: false
    }
  },
  computed: {
    logoPath() {
      return config.logoPath;
    },
    cnyMode() {
      return config.cnyMode;
    },
    logoCNYPath() {
      return config.logoCNYPath;
    },
    brand() {
      return config.brand;
    },
    desktopUrl() {
      let domain = window.location.hostname
      return "https://" + domain.replace("m.", "") + "?view=desktop"
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    esports2() {
      return config.esports2 == "1";
    }
  },
  beforeMount() {
    this.getMobile()
  },
  destroyed() {
    clearInterval(this.countdown);
  },
  mounted() {
    if (this.$route.query.redirect) {
      this.$swal("Info", this.$t("message.login"), "info").then(result => {
        // this.$router.push("/");
      });
    }

    $("#main-carousel").on("slide.bs.carousel", function(e) {
      if (e.relatedTarget.id == "sport") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_bg.jpg)");
      } else if (e.relatedTarget.id == "casino") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_casino_bg.jpg)");
      } else if (e.relatedTarget.id == "games") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_games_bg.jpg)");
      } else if (e.relatedTarget.id == "live") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_live_bg.jpg)");
      } else if (e.relatedTarget.id == "efight") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_esport_bg.jpg)");
      } else if (e.relatedTarget.id == "efight2") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_tfgaming_bg.jpg)");
      } else if (e.relatedTarget.id == "worldcup") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_worldcup_bg.jpg)");
      } else if (e.relatedTarget.id == "vgames") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_racing_bg.jpg)");
      } else if (e.relatedTarget.id == "tournament") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_tournament_bg.jpg)");
      } else if (e.relatedTarget.id == "live22") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_live22_bg.jpg)");
      } else if (e.relatedTarget.id == "songkran") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_songkran_bg.jpg)");
      } else if (e.relatedTarget.id == "raya") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_ramadan_bg.jpg)");
      } else if (e.relatedTarget.id == "dragonboat") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/mobile/landing/slider_dragonboat_bg.jpg)");
      }
    });

    $(".carousel-control-next,carousel-control-prev").click(function() {
      $(".bg-landing").removeClass("fadeInSlider");
    });

    this.$nextTick(() => {
      // console.log(this.$dayjs().isSameOrAfter('2022-11-16', 'day'))
      // this.countdown = setInterval(() => {
      //   var countDownDate = new Date("Nov 20, 2022 23:59:59").getTime();
      //   var now = new Date().getTime();

      //   var distance = countDownDate - now;
      //   var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      //   var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      //   var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      //   var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      //   document.getElementById("timer").innerHTML =
      //     '<div>' + days + '<span>days</span></div>' +
      //     '<div>' + hours + '<span>hours</span></div>' +
      //     '<div>' + minutes + '<span>minutes</span></div>' +
      //     '<div>' + seconds + '<span>seconds</span></div>' ;

      //   if (distance < 0) {
      //     clearInterval(this.countdown);
      //     $(".worldcup-timer").addClass('d-none');
      //   }
      // }, 1000)
      if (this.brand == "WBET" && this.cnyMode) {
        specialfx();
      }
      $(".carousel").carousel({
        interval: 5000
      });
    });
  },
  methods: {
    getImgUrl(e) {
      return config.resourceImgUrl + '/mobile/landing/' + e;
    },
    close(e) {
      switch(e) {
        case 0:
          this.isAndroid = false;
          break;
        case 1:
          this.isIOS = false;
          break;
      }
    },
    getMobile() {
      let isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
      }

      if (isMobile.iOS()) {
        this.isIOS = true
      } else {
        this.isIOS = false
      }

      if (isMobile.Android()) {
        this.isAndroid = true
      } else {
        this.isAndroid = false
      }

      if (isMobile.Windows()) {
        this.isWindows = true
      } else {
        this.isWindows = false
      }
    },
  }
};
</script>
